export default {
  GET_STATES: 'GET_STATES',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_USER: 'SET_USER',
};
